import server from '../request';

export default {
  // 获取菜单树
  getMenuTree (params = {}) {
    return server.post('/xiaozi-saas/wireless/menu/menuTree', params);
  },

  // 新增菜单
  addMenu (params) {
    return server.post('/xiaozi-saas/wireless/menu/add', params);
  },

  // 批量新增菜单
  batchAddMenu (params) {
    return server.post('/xiaozi-saas/wireless/menu/batchAdd', params);
  },

  // 删除菜单
  deleteMenu (id) {
    return server.post('/xiaozi-saas/wireless/menu/delete', {id});
  },
};
